<template>
    <div>
        <v-row v-if="ready">
            <v-col cols="12">
                <v-row>
                    <v-col cols="12" md="3"> <info :group="group.name"/> </v-col>
                    <v-col cols="12" md="3"> <value v-if="lastReading" :reading="lastReading" :prop="'watts'"/> </v-col>
                    <v-col cols="12" md="3"> <value v-if="lastReading" :reading="lastReading" :prop="'amps'"/> </v-col>
                    <v-col cols="12" md="3"> <value v-if="lastReading" :reading="lastReading" :prop="'volts'"/> </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <mapMeter :meters="group.meters" :location="center" :groupName="group.name"/>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <control :group="group"/>
                    </v-col>
                </v-row>
                <v-row class="mt-n1">
                    <v-col cols="12" md="6" > 
                        <GraphsGroup
                            :meter="group.meters"
                            historic 
                            :graph="new Chart({
                                name: 'KWH month',
                                props: [KWH],
                                type: COLUMS 
                            })"/>
                    </v-col>
                    <v-col cols="12" md="6">
                        <GraphsGroup
                            :meter="group.meters" 
                            :graph="new Chart({
                                name: 'Power (KW)',
                                lines: [LINE1, LINE2, LINE3 ],
                                props: [WATTS],
                                type: LINES
                            })"/>
                    </v-col>
                    <v-col cols="12" md="6">
                        <GraphsGroup
                            :meter="group.meters" 
                            :graph="new Chart({
                                name: 'Voltage',
                                props: [VOLTS],
                                lines: [LINE1, LINE2, LINE3 ],
                                type: LINES
                            })"/>
                    </v-col>
                    <v-col cols="12" md="6">
                        <GraphsGroup 
                            :meter="group.meters" 
                            :graph="new Chart({
                                name: 'Current',
                                lines: [LINE1, LINE2, LINE3 ],
                                props: [AMPS],
                                type: LINES
                            })"/>
                    </v-col> 
                </v-row>
            </v-col>
        </v-row>
        <v-row v-else style="height: 100%; position: relative;">
            <v-col v-if="allOut" align="center" justify="center" style="position: absolute; top: 280px">
                <v-icon class="mb-3" x-large>mdi-alert-outline</v-icon>
                <br>
                Oh no! It seems there aren't any devices connected, please test and reconnect
            </v-col>
            <v-col v-else align="center" justify="center" style="position: absolute; top: 280px">
                <v-progress-circular
                    class="pcirc"
                    width="5"
                    size="50"
                    indeterminate
                    color="accent"
                ></v-progress-circular>
            </v-col>
        </v-row>
    </div>
</template>


<script>
import { LINE1, LINE2, LINE3 } from '../components/graphs/props-types'
import { WATTS, AMPS, VOLTS, KWH } from '../components/graphs/props-types'
import { COLUMS, LINES } from '../components/graphs/props-types'
import Chart from '../components/graphs/modules/Chart.js'
import control from '../components/GroupCircuit/control'
import mapMeter from '../components/GroupCircuit/map'
import value from '../components/GroupCircuit/value'
import info from '../components/GroupCircuit/info'
import { GraphsGroup } from "../components/graphs";
import { mapGetters, mapState, mapActions } from 'vuex'

export default {
    name: 'GroupCircuit',
    components: { info, value, mapMeter, control, GraphsGroup },
    computed: {
        ...mapState({
            records: (state) => state.meters.lastReadings,
            arrayOUT: (state) => state.meters.arrayOUT
        }),
        ...mapGetters({
            getMeter: "meters/getMeter",
            getLastReading: "meters/getLastReading",
            getGroup: "meters/getGroup"
        }),
    },
    data() {
        return {
            Chart,WATTS, AMPS, VOLTS, KWH, COLUMS, 
            LINES,LINE1, LINE2, LINE3,
            ready: false,
            width: 0,
            lastReading: {},
            center: {},
            group: null,
            allOut: false
        };
    },
    methods:{
        ...mapActions({ lastReadings: 'meters/lastReadings' }),
        async refresh(){
            this.ready = false
            let group = this.$route.params.id
            this.group = this.getGroup(group)
            if(this.group) {
                localStorage.setItem('group', JSON.stringify(this.group))
            }
            if(!this.group) {
                this.group = JSON.parse(localStorage.getItem('group'))
            }
            await this.detectOut(this.group.meters)
            if (this.allOut === true) return
            await this.retrieveReadings()
            await this.retrieveLocation()
            await this.sleep(2000).then(() => { this.ready = true });
        },
        retrieveReadings(){
            let arrayRecords = JSON.parse(localStorage.getItem('records'))
            let records = arrayRecords.filter( r => r != undefined )
            let meters = this.group.meters
            let wTotal = []; let aTotal = []; let vTotal = []
            meters.forEach(m => {
                let read = records.find(r => r.meter === m.name)
                let w = Number(read.lines.reduce( (suma, l) => suma + l.watts, 0 ).toFixed(2)); wTotal.push(w)
                let a = Number(read.lines.reduce( (suma, l) => suma + l.amps, 0 ).toFixed(2)); aTotal.push(a)
                let v = Number((Object.entries(
                                read.lines.reduce( (acc, l) => l.volts > 10 ? acc = { suma: acc.suma + l.volts, lines: acc.lines + 1} : acc , 
                                { suma: 0, lines: 0} ) ).reduce( (total, el) => {
                                    if(el[0] == 'suma') return total + el[1]; else if(total == 0) return 0; else return total / el[1] 
                                }, 0)).toFixed(2)); vTotal.push(v)
            });
            let sumW = 0; let sumA = 0; let avgV = 0
            for (let i = 0; i < meters.length; i++) { sumW += wTotal[i]; sumA += aTotal[i]; avgV += vTotal[i]/meters.length }
            this.lastReading = { watts: sumW.toFixed(2), amps: sumA.toFixed(2), volts: avgV.toFixed(2) }
        },
        retrieveLocation(){
            let meters = this.group.meters
            let lats = []; let lngs = []
            meters.forEach(m => {
                if(m.location.ef) lats.push(m.location.ef)
                else lats.push(m.location.latitude)
                if(m.location.nf) lngs.push(m.location.nf)
                else lngs.push(m.location.longitude)
            })
            let avgLat = 0; let avgLng = 0
            for (let i = 0; i < meters.length; i++) { avgLat += lats[i]/meters.length; avgLng += lngs[i]/meters.length }
            this.center = { lat: avgLat, lng: avgLng }
        },
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        async detectOut(meters){
            let c = 0
            for (let index = 0; index < meters.length; index++) {
                const element = meters[index]
                let meterOUT = this.arrayOUT.find(m => m.name === element.name)
                if (meterOUT != undefined) c += 1
            }
            if(c === meters.length) await this.sleep(4000).then(() => { this.allOut = true });
        }
    },
    watch:{
        '$route.params.id'(){
            this.refresh()
        },
    },
    mounted(){
        this.refresh()
        if(this.records) localStorage.setItem('records', JSON.stringify(this.records))
    },
    beforeDestroy() {
        if(this.$route.name != 'GroupCircuit') {
            localStorage.removeItem('group')
            localStorage.removeItem('records')
        }
    },
}
</script>

<style scoped>
</style>